'use strict';

import fd, {mutate} from '../parent/js/lib/promise-fastdom';
import ToggleArea from '../parent/js/lib/ToggleArea';
import nodeFromTemplate from '../parent/js/lib/node-from-template';
import ButtonBehavior from '../parent/js/lib/ToggleArea_ButtonBehavior';
import initHandlers from '../parent/js/nav-events';
import BreakpointMode from "../../../group/src/js/lib/BreakpointMode";
import Mode from "../../../group/src/js/lib/Mode";
import insertAtPosition from "../../../group/src/js/lib/insert-at-position";

export default function init() {
    return fd.mutate(function () {

        let nav;

        const root = document.documentElement;
        const headerMenu = document.querySelector('.nav__header > .menu');
        const mainMenu = document.querySelector('.nav__main > .menu');
        const langsItem = headerMenu.querySelector('.menu-lang');
        const searchItem = headerMenu.querySelector('.icon-search');
        const metaItems = headerMenu.querySelectorAll('.menu-item:not(.mobile)');
        const button = nodeFromTemplate('nav-toggle-tpl');
        const area = document.getElementById(button.getAttribute('aria-controls'));
        const navInner = area.querySelector('.nav__inner');

        const buttonItem = document.createElement('li');
        buttonItem.setAttribute('class', 'menu-item mobile nav-toggle-item');
        buttonItem.appendChild(button);

        initHandlers(nav, area, button);

        BreakpointMode.namedBreakpoint('desktop-max').then(width => {

            const metaPositions = new Map();
            metaItems.forEach(item => {
                metaPositions.set(item, Array.from(item.parentNode.childNodes).indexOf(item));
            });

            new BreakpointMode(window.matchMedia(`screen and (max-width:${width})`), new Mode(
                () => fd.mutate(() => {

                    metaItems.forEach(item => mainMenu.appendChild(item));

                    headerMenu.insertAdjacentElement('afterbegin', buttonItem);
                    buttonItem.appendChild(area);
                    nav = new ToggleArea(area, 'nav', [
                        new ButtonBehavior(button, {
                            closeOnLinkClick: false,
                            closeOnOutsideClick: false,
                            closeOnBlur: true,
                            jail: false,
                        })
                    ]);
                    return nav.ready();
                }),
                nav => nav.destroy().then(mutate(() => {
                    metaItems.forEach(item => insertAtPosition(headerMenu, item, metaPositions.get(item)));
                    root.classList.remove('nav-on');
                    document.querySelector('.nav__header').insertAdjacentElement('afterend', area);
                    buttonItem.remove();
                }))
            ));
        });

        function getMoveMode(node, targetMove) {
            const parent = node.parentNode;
            return new Mode(
                () => fd.mutate(() => {
                    const position = Array.from(parent.childNodes).indexOf(node);
                    targetMove(node);
                    node.classList.add('moved');
                    return position;
                }),
                (position) => fd.mutate(() => {
                    insertAtPosition(parent, node, position);
                    node.classList.remove('moved');
                })
            )
        }

        langsItem && BreakpointMode.namedBreakpoint('langs-max').then(width => {
            new BreakpointMode(
                window.matchMedia(`screen and (max-width:${width})`),
                getMoveMode(langsItem, node => insertAtPosition(navInner, node, 2))
            );
        });

        searchItem && BreakpointMode.namedBreakpoint('search-max').then(width => {
            new BreakpointMode(
                window.matchMedia(`screen and (max-width:${width})`),
                getMoveMode(searchItem, node => navInner.insertAdjacentElement('beforeend', node))
            );
        });
    });
}